/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import history from 'utils/history';
import auth from './auth/reducer';
import table from './table/reducer';
import table2 from './table2/reducer';
import api from './libs/reducer';
import game from './game/reducer';
import profile from './profile/reducer';
import rate from './rate/reducer';
import payment from './payment/reducer';
import tutorial from './tutorial/reducer';
import results from './results/reducer';
import openStats from './openStats/reducer';
import postflop from './postflop/reducer';

export default () => combineReducers({
  router: connectRouter(history),
  auth,
  table,
  table2,
  api,
  game,
  profile,
  rate,
  payment,
  tutorial,
  results,
  openStats,
  postflop,
});
